import styled from 'styled-components';
import { editorTheme } from '../../theme';

const ButtonComponent = styled.button`
  align-items: center;
  justify-content: center;
  display: flex;
  min-width: 32px;
  height: 30px;
  padding: 0 6px;
  border-radius: 6px;
  background: none;
  color: ${editorTheme.text};
  cursor: pointer;
  &:hover {
    background: ${editorTheme.surface};
    color: ${editorTheme.accentHover};
  }
`;

export default ButtonComponent;
